import React, {Component} from 'react';
import {Field} from 'formik';
import {parsers} from '@neosvoc/nv-platform-core-common';
import SingleChoiceField from './SingleChoiceField';
import SingleChoiceSelectField from './SingleChoiceSelectField';

class SingleChoiceType extends Component {
    constructor(props) {
        super(props);
        this.validate = this.validate.bind(this);
        this.validateDetail = this.validateDetail.bind(this);
    }

    validate(value) {
        try {
            parsers.singleChoice(value, this.props);
        } catch (err) {
            return err.payload;
        }
    }

    validateDetail(value) {
        // small hack to throw error on detail sub-field
        try {
            parsers.string(value, {required: true});
        } catch (err) {
            return err.payload;
        }
    }

    render() {
        let component = SingleChoiceField;
        if (this.props.style === 'select') {
            component = SingleChoiceSelectField;
        }
        return (
            <Field name={this.props.id} choices={this.props.choices} component={component} validate={this.validate} validateDetail={this.validateDetail}
                previousContent={this.props.previousContent} />
        );
    }
}

export default SingleChoiceType;
